var Handlebars = require("C:\\TeamCityAgents\\02\\work\\bbe988d6cf529cbd\\CMS\\App_Themes\\DeleteKenticoFramework\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"container container--narrow\">\r\n    <div class=\"jg-donations__empty\">\r\n        There has not been any recent donations, click <a class=\"link\" href=\"#\">here</a> if you would like to show your\r\n        support\r\n    </div>\r\n</div>\r\n\r\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/components/jg-donations/html/jg-donations-empty.hbs
// module id = grUI
// module chunks = 0